import {
  AutomationStatus,
  MessageStatus,
  TaskStatus
} from '@dadohr/shared/domainTypes/experience';
import { isExperienceUserActor } from '../../../../../services/experiences/instance';
import { ListItem } from './PreviewAndConfigureDialogContent';

export const getInstancesDataForTracking = (
  ds: ListItem[],
  originalDs: ListItem[]
) => {
  const changedSupportingActorsInstanceIDs = new Set();
  const skippedItemsInstanceIDs = new Set();
  const changedAnchorsInstanceIDs = new Set();

  ds.forEach((d, index) => {
    // Actors change
    const originalD = originalDs[index];
    const editableActors = d.instance.data.actors.filter(isExperienceUserActor);
    originalD &&
      originalD.instance.data.actors
        .filter(isExperienceUserActor)
        .forEach((a, i) => {
          const m = editableActors[i];
          // `m` is undefined when the editable instance has fewer user-actors than
          // the original — e.g. after deselecting/removing an actor. Treat a missing
          // counterpart as a change (and stop reading `m.userId` on undefined, which
          // crashed the modal: "Cannot read properties of undefined (reading 'userId')").
          if (!m || a.userId !== m.userId) {
            changedSupportingActorsInstanceIDs.add(d.instance.id);
          } else return;
        });

    // Skipped items
    d.instance.data.tasks.forEach((task) => {
      if (task.status !== TaskStatus.SKIPPED) {
        return;
      }
      return skippedItemsInstanceIDs.add(d.instance.id);
    });

    Object.entries(d.instance.data.messagesStatuses).forEach(
      ([msgId, msgStatus]) => {
        if (msgStatus.status !== MessageStatus.SKIPPED) {
          return;
        }
        return skippedItemsInstanceIDs.add(d.instance.id);
      }
    );

    Object.entries(d.instance.data.automations).forEach(
      ([automationId, automation]) => {
        if (automation.status !== AutomationStatus.SKIPPED) {
          return;
        }
        return skippedItemsInstanceIDs.add(d.instance.id);
      }
    );

    // anchor change
    if (
      originalD &&
      originalD.instance.data.anchorDate.at.isEqual(
        d && d.instance.data.anchorDate.at
      )
    ) {
      return;
    } else {
      return changedAnchorsInstanceIDs.add(d.instance.id);
    }
  });

  return {
    skippedItems: skippedItemsInstanceIDs.size,
    supportingActors: changedSupportingActorsInstanceIDs.size,
    anchors: changedAnchorsInstanceIDs.size
  };
};
